import React from 'react'
import DashboardHeader from '../Integration/DashboardHeader'
import SuplierDash from '../Integration/SuplierDash'
import FbBusinessOrderNova from '../../Middleware/Firebase/FbBusinessOrderNova'





function PageSupplierOrder() {
  return (
    
    <div>

        <DashboardHeader/>
        <SuplierDash/>
    <FbBusinessOrderNova/>

    </div>


  )
}

export default PageSupplierOrder